function validateSsn(ssn) {
	if (_.isString(ssn)) {
		if (ssn.length === 11) {
			var org = _.map(_.toArray(ssn), function (e) { return parseInt(e, 10) }),
				arr = org.slice(0, 9),
				kt1 = [3, 7, 6, 1, 8, 9, 4, 5, 2],
				kt2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2],
				r1 = 0,
				r2 = 0;

			for (var i = 0; i < arr.length; i++) {
				r1 += arr[i] * kt1[i];
			}

			arr.push(r1 % 11 === 0 ? 0 : (11 - (r1 % 11)));

			for (var i = 0; i < arr.length; i++) {
				r2 += arr[i] * kt2[i];
			}

			arr.push(r2 % 11 === 0 ? 0 : (11 - (r2 % 11)));

			return arr.join('') === org.join('');
		}
	}
	return false;
};

function validateSsn_se(ssn) {
	if (ssn.length === 11 || ssn.length === 10) {
		const digits = ssn.toString().split('').map(Number);

		for (var i = digits.length - 2; i >= 0; i -= 2) {
			digits[i] *= 2;

			if (digits[i] > 9) {
				digits[i] -= 9;
			}
		}

		var sum = 0;
		for (var i = 0; i < digits.length; i++) {
			sum += digits[i];
		}

		return sum % 10 === 0;
	}
	return false;
};


function validateSsn_fi(ssn) {
	if (_.isString(ssn)) {
		if (ssn.length === 11) {
			return /^[0-9]{6}-(?:[0-9]+){1,3}[0-9A-Za-z]$/.test(ssn);
		}
	}
	return false;
};

function validateMobileAndBirthdate(mobile, birthdate) {
	return !isNaN(birthdate) && birthdate.length === 6
		&& !isNaN(mobile) && mobile.length === 8;
};
